import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

interface ToothLoaderProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  message?: string;
}

export const ToothLoader = ({ size = "md", className, message }: ToothLoaderProps) => {
  const sizeMap = {
    sm: "h-5 w-5",
    md: "h-8 w-8",
    lg: "h-12 w-12"
  };

  return (
    <div className={cn("flex flex-col items-center justify-center gap-3", className)}>
      <Loader2 className={cn("animate-spin text-primary", sizeMap[size])} />
      {message && (
        <p className="text-sm text-muted-foreground animate-pulse">{message}</p>
      )}
    </div>
  );
};
